import React, { useState } from 'react';

import useFilterForCheckbox from '../hooks/useFilterForCheckbox';
import FilterItem from './FilterItem';

/**
 * FilterAuthorLastInitial
 *
 * A filter that returns author last names starting with a letter of the alphabet
 *
 * @param {Object} props
 * @param {Object} props.setStart
 * @param {string} props.dataCode
 * @param {string} props.title
 * @param {Object} props.scrollToTop
 * @see https://javascript.plainenglish.io/create-an-array-of-alphabet-characters-in-javascript-with-this-simple-trick-930033079dd3
 */
const FilterAuthorLastInitialListItem = ({ setStart, dataCode, scrollToTop }) => {
  const [ isActive, setIsActive ] = useState( false );
  const {
    checked,
    setChecked,
    handleFilter
  } = useFilterForCheckbox( setStart, dataCode, scrollToTop );

  const alpha = Array.from( Array( 26 ) ).map( ( e, i ) => i + 65 );
  const alphabet = alpha.map( ( x ) => String.fromCharCode( x ) );

  return (
    <FilterItem
      data={ alphabet }
      setStart={ setStart }
      title="Author (Last Name)"
      scrollToTop={ scrollToTop }
      isActive={ isActive }
      setIsActive={ setIsActive }
      checked={ checked }
      setChecked={ setChecked }
      handleFilter={ handleFilter }
    />
  );
};

export default FilterAuthorLastInitialListItem;
